export default __webpack_public_path__ + "static/media/7.bbc1d83c.svg";